import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow, PreviewImage } from "../../components/index";
import { CustomForm } from "../../forms/CustomFormForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const CustomFormTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: CustomFormTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [deleteCustomFormModalShowing, setDeleteCustomFormModalShowing] =
        useState(false);
    const [deleteCustomFormName, setDeleteCustomFormName] = useState("");
    const [deleteCustomFormId, setDeleteCustomFormId] = useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>{trans("Name")}</th>
                        <th>
                            <TableHeader onClick={() => onOrderBy("slug")}>
                                {trans("Alias")}
                            </TableHeader>
                        </th>
                        {/* <th>
                            <TableHeader onClick={() => onOrderBy("order")}>
                                {trans("Order")}
                            </TableHeader>
                        </th> */}
                        {/* <th>{trans("Image")}</th> */}
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={"100%"}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={"100%"}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr key={item.uuid}>
                                    <td>{item.name}</td>
                                    <td>{item.alias}</td>
                                    {/* <td>{item.order}</td> */}
                                    {/* <td>
                                        {item.thumbnail ? (
                                            <PreviewImage
                                                src={item.thumbnail}
                                            />
                                        ) : (
                                            trans("No image provided")
                                        )}
                                    </td> */}
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteCustomFormId(
                                                    item.uuid
                                                );
                                                setDeleteCustomFormModalShowing(
                                                    true
                                                );
                                                setDeleteCustomFormName(
                                                    item.name
                                                );
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteCustomFormModalShowing && (
                <Modal
                    visible={deleteCustomFormModalShowing}
                    onClose={() => {
                        setDeleteCustomFormModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h3>
                            {trans(
                                "You are about delete: {deleteCustomFormName}",
                                {
                                    deleteCustomFormName,
                                }
                            )}
                        </h3>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="secondary"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteCustomFormModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteCustomFormId).then(() => {
                                    setDeleteCustomFormModalShowing(false);
                                });
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface CustomFormTableProps {
    items: CustomForm[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<CustomForm[]>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: ({ value }) => void;
}

export default CustomFormTable;
